import type { FAQPage, WithContext, Question } from 'schema-dts';

export function FAQPageSchema({
  items,
}: Readonly<{ items: { question: string; answer: string }[] }>) {
  const faqPageSchema = generateFAQPage(items);

  if (!faqPageSchema) return null;

  // See new next.js best practise https://nextjs.org/docs/app/guides/json-ld
  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: faqPageSchema }} />;
}

function generateFAQPage(faqPageItems: { question: string; answer: string }[] | undefined) {
  if (!faqPageItems || faqPageItems.length === 0) return undefined;

  const mainEntity: Question[] = [];
  const faqPage: WithContext<FAQPage> = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
  };

  faqPageItems.forEach(({ question, answer }) => {
    const entry: Question = {
      '@type': 'Question',
      name: question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: answer,
      },
    };

    mainEntity.push(entry);
  });

  faqPage.mainEntity = mainEntity;

  return JSON.stringify(faqPage);
}
